import { Controller } from "@hotwired/stimulus"
import { createElement } from "react"
import { createRoot } from "react-dom/client"
import PipelineCanvas from "../gtm/PipelineCanvas.jsx"

// Loader controller: bridges a Rails-rendered DOM mount point to a self-contained
// React Flow canvas. The React island owns nothing outside this element — no
// routing, no global layout, no history — just the graph.
export default class extends Controller {
  static values = {
    graph: Object,
    editable: { type: Boolean, default: false },
    graphUrl: String,
    stepTypes: Array,
    configOptions: Object,
    csrfToken: String
  }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(
      createElement(PipelineCanvas, {
        graph: this.graphValue,
        editable: this.editableValue,
        graphUrl: this.graphUrlValue,
        stepTypes: this.stepTypesValue,
        configOptions: this.configOptionsValue,
        csrfToken: this.csrfTokenValue
      })
    )
  }

  disconnect() {
    this.root?.unmount()
    this.root = null
  }
}
